<template>
  <div>
    <wc-section-title title='Timesheets'>
      <template v-slot:rightSide v-if='$vuetify.breakpoint.smAndDown'>
        <v-btn
          v-if='$route.name !== "TimesheetsDashboard"'
          large
          icon
          color='info'
          @click='returnToDashboard'
        >
          <v-icon large>mdi-view-list</v-icon>
        </v-btn>
      </template>
    </wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'timesheets-base',
  computed: {
    menu () {
      return [
        {
          title: 'Timesheets Dashboard',
          icon: this.$store.state.icons.modules.timesheets.icon,
          route: { name: 'TimesheetsDashboard' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Timesheets Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  },
  methods: {
    returnToDashboard () {
      this.$router.push({ name: 'TimesheetsDashboard' })
    }
  }
}
</script>
